import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    sendProductMessage,
    sendProductAdvertisment,
} from '../Actions/ProductInfo.action';
import { translate } from '../Services/translation';
import DynamicComponent from './DynamicComponent';

const ProductInfoButtons = (props) => {
    const productId = props.productId;
    const phoneNumber = `tel:${translate('product.companyinfo.phone.number')}`;
    const [selection, setSelection] = useState('');
    const [emailData, setEmailData] = useState('');
    const [messageData, setMessageData] = useState('');
    const [receiverNameData, setReceiverNameData] = useState('');
    const [senderNameData, setSenderNameData] = useState('');
    const dispatch = useDispatch();
    const mailSelector = useSelector((state) => state.mailProduct);

    const handleSubmitAdvertise = (event) => {
        event.preventDefault();
        const data = {
            email: emailData,
            productId: productId,
            senderName: senderNameData,
            receiverName: receiverNameData,
        };
        dispatch(sendProductAdvertisment(data));
    };

    const PdfButton = DynamicComponent({
        loader: () => import('./ButtonPdf'),
    });

    const handleSubmitEmail = (event) => {
        event.preventDefault();
        const data = {
            email: emailData,
            productId: productId,
            senderName: senderNameData,
            message: messageData,
        };
        dispatch(sendProductMessage(data));
    };

    return (
        <div className="product-info__actions-container">
            <div className="product-info__buttons">
                <button
                    onClick={() => setSelection(() => 'advertise')}
                    className="product-info__button"
                >
                    <i className="product-info__chat-icon"></i>
                    {translate('product.actions.advertise')}
                </button>
                <button href={phoneNumber} className="product-info__button">
                    <i className="product-info__phone-icon"></i>
                    {translate('product.actions.call')}
                </button>
                <button
                    onClick={() => setSelection(() => 'mail')}
                    className="product-info__button"
                >
                    <i className="product-info__mail-icon"></i>
                    {translate('product.actions.mail')}
                </button>
                <PdfButton variantId={productId} />
            </div>

            <Accordion
                selection={selection}
                isLoading={mailSelector.isLoading}
                isSuccessful={mailSelector.isSuccessful}
                haveResponded={mailSelector.haveResponded}
                senderName={{
                    value: senderNameData,
                    handler: (event) => setSenderNameData(event.target.value),
                }}
                receiverName={{
                    value: receiverNameData,
                    handler: (event) => setReceiverNameData(event.target.value),
                }}
                email={{
                    value: emailData,
                    handler: (event) => setEmailData(event.target.value),
                }}
                message={{
                    value: messageData,
                    handler: (event) => setMessageData(event.target.value),
                }}
                onAdvertiseSubmit={handleSubmitAdvertise}
                onMailSubmit={handleSubmitEmail}
            />
        </div>
    );
};

const Accordion = (props) => {
    if (props.selection) {
        if (props.selection === 'advertise') {
            return (
                <TipForm
                    email={props.email}
                    senderName={props.senderName}
                    receiverName={props.receiverName}
                    onAdvertiseSubmit={props.onAdvertiseSubmit}
                    isLoading={props.isLoading}
                    isSuccessful={props.isSuccessful}
                    haveReponded={props.haveResponded}
                />
            );
        } else if (props.selection === 'mail') {
            return (
                <MailForm
                    email={props.email}
                    senderName={props.senderName}
                    message={props.message}
                    onMailSubmit={props.onMailSubmit}
                    response={props.mailResponse}
                    isLoading={props.isLoading}
                    isSuccessful={props.isSuccessful}
                    haveReponded={props.haveResponded}
                />
            );
        }
    }
    return null;
};

const MailForm = (props) => {
    return (
        <form
            onSubmit={props.onMailSubmit}
            className="product-info__forms-container"
        >
            <div className="product-info__forms-container__form-control">
                <label className="form__labdotnet rel" htmlFor="mailAddress">
                    {translate('product.actions.address-label')}
                </label>
                <input
                    className="form__input"
                    id="mailAddress"
                    name="mailAddress"
                    type="email"
                    value={props.email.value}
                    onChange={props.email.handler}
                    required={true}
                />
            </div>
            <div className="product-info__forms-container__form-control">
                <label className="form__labdotnet rel" htmlFor="mailSenderName">
                    {translate('product.actions.sender-label')}
                </label>
                <input
                    className="form__input"
                    id="mailSenderName"
                    name="mailSenderName"
                    type="text"
                    value={props.senderName.value}
                    onChange={props.senderName.handler}
                    required={true}
                />
            </div>
            <div className="product-info__forms-container__form-control">
                <label className="form__labdotnet rel" htmlFor="message">
                    {translate('product.actions.message-label')}
                </label>
                <textarea
                    className="form__input"
                    id="message"
                    name="message"
                    value={props.message.value}
                    onChange={props.message.handler}
                    required={true}
                />
            </div>
            <div>
                <button className="product-info__button confirm" type="submit">
                    {translate('product.actions.submit-button-text')}
                </button>
                <ActionStatus
                    isLoading={props.isLoading}
                    isSuccessful={props.isSuccessful}
                    haveResponded={props.haveReponded}
                />
            </div>
        </form>
    );
};

const TipForm = (props) => {
    return (
        <form
            onSubmit={props.onAdvertiseSubmit}
            className="product-info__forms-container"
        >
            <div className="product-info__forms-container__form-control">
                <label
                    className="form__labdotnet rel"
                    htmlFor="advertiseReceiverName"
                >
                    {translate('product.actions.receiver-label')}
                </label>
                <input
                    className="form__input"
                    id="advertiseName"
                    name="advertiseName"
                    type="text"
                    value={props.receiverName.value}
                    onChange={props.receiverName.handler}
                />
            </div>
            <div className="product-info__forms-container__form-control">
                <label className="form__labdotnet rel" htmlFor="mailAddress">
                    {translate('product.actions.address-label')}
                </label>
                <input
                    className="form__input"
                    id="mailAddress"
                    name="mailAddress"
                    type="email"
                    value={props.email.value}
                    onChange={props.email.handler}
                    required={true}
                />
            </div>
            <div className="product-info__forms-container__form-control">
                <label
                    className="form__labdotnet rel"
                    htmlFor="advertiseSenderName"
                >
                    {translate('product.actions.sender-label')}
                </label>
                <input
                    className="form__input"
                    id="advertiseSenderName"
                    name="advertiseSenderName"
                    type="text"
                    value={props.senderName.value}
                    onChange={props.senderName.handler}
                    required={true}
                />
            </div>
            <div>
                <button className="product-info__button confirm" type="submit">
                    {translate('product.actions.submit-button-text')}
                </button>
                <ActionStatus
                    isLoading={props.isLoading}
                    isSuccessful={props.isSuccessful}
                    haveResponded={props.haveReponded}
                />
            </div>
        </form>
    );
};

const ActionStatus = (props) => {
    if (props.isLoading) {
        return (
            <span className="product-info__action-message loading">
                {translate('product.actions.loading')}
            </span>
        );
    } else if (!props.isLoading && props.isSuccessful && props.haveResponded) {
        return (
            <span className="product-info__action-message success">
                {translate('product.actions.success-message')}
            </span>
        );
    } else if (!props.isLoading && !props.isSuccessful && props.haveResponded) {
        return (
            <span className="product-info__action-message error">
                {translate('product.actions.error-message')}
            </span>
        );
    }
    return null;
};

export default ProductInfoButtons;
